import * as React from 'react';
import aos from '@src/utils/aos';
import CmsRichText from '../cms-rich-text';
import styles from './index.less';

const GuildAssembly = ({ content }) => (
  <div className={styles.root}>
    <section className={`${styles.contentSession} ${styles.introSession}`} aria-label="帮会集结概述">
      <div className={styles.content}>
        <div className={styles.intro} data-aos-duration="600" data-aos-once="true" {...aos.FADE_RIGHT()}>
          <CmsRichText className={styles.richText} html={content.guildDescriptionHtml} />
        </div>
      </div>
    </section>
    <section className={`${styles.contentSession} ${styles.rulesSession}`} aria-label="集结规则">
      <div className={styles.content}>
        <h2 className={styles.title} data-aos-duration="600" data-aos-once="true" {...aos.FADE_DOWN()}>
          帮会集结
        </h2>
        <div className={styles.rules} data-aos-duration="600" data-aos-once="true" {...aos.FADE_UP()}>
          <CmsRichText className={styles.richText} html={content.guildRulesHtml} />
        </div>
      </div>
    </section>
    <section className={`${styles.contentSession} ${styles.copyrightSession}`} aria-label="活动最终解释权说明">
      <div className={styles.content}>
        <p className={styles.copyright}>*本次活动最终解释权归金山西山居所有！</p>
      </div>
    </section>
  </div>
);

GuildAssembly.defaultProps = {
  content: {}
};

export default GuildAssembly;
